import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const language = navigator.language.substr(0, 2);

const i18n = new VueI18n({
  locale: language,
  messages: {
    zh: require('./assets/lang/zh').default,
    en: require('./assets/lang/en').default,
    en_ml: require('./assets/lang/en-ml').default,
    zh_ml: require('./assets/lang/zh-ml').default
  }
});

export default i18n;
